import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { map, switchMap, catchError } from 'rxjs/operators';
import {
  CAMPAIGN_SIGN_UP,
  CAMPAIGN_SIGN_UP_SUCCESS
} from '../../constants';

const campaignSignUp = (action$, state$) =>
  action$.pipe(
    ofType(CAMPAIGN_SIGN_UP),
    switchMap(action => {
      console.log(action.payload)
      return ajax({
        url:  `${state$.value.auth.server}/campaigns/${action.campaignId}/shares/${action.shareId}/signup`,
        headers: {
          Authorization: state$.value.auth.token,
          'Content-Type': `multipart/form-data; boundary=123`
        },
        responseType: 'json',
        crossDomain: true,
        body: JSON.stringify(action.payload),
        method: 'POST',
      }).pipe(
        map(response => {
          console.log(response.response);
          return {
            type: CAMPAIGN_SIGN_UP_SUCCESS,
            data: response.response
          };
        }),
        catchError(error => {
          console.log(error);
        })
      );
    })
  );

export default campaignSignUp;
